/* eslint-disable prefer-const */
/* eslint-disable complexity */
import { CatalogExporter } from '@app/app/data/catalog-exporter';
import { countryCodeList, countryNameList } from '@app/app/data/catalogs/countries';
import { GetSatType, MenuMode, ToastMsgType } from '@app/engine/core/interfaces';
import { ServiceLocator } from '@app/engine/core/service-locator';
import { EventBus } from '@app/engine/events/event-bus';
import { EventBusEvent } from '@app/engine/events/event-bus-events';
import { html } from '@app/engine/utils/development/formatter';
import { errorManagerInstance } from '@app/engine/utils/errorManager';
import { getEl } from '@app/engine/utils/get-el';
import { getUnique } from '@app/engine/utils/get-unique';
import { hideLoading, showLoading } from '@app/engine/utils/showLoading';
import { eci2rae } from '@ootk/src/main';
import findSatPng from '@public/img/icons/database-search.png';
import { KeepTrackPlugin } from '../../engine/plugins/base-plugin';
export class FindSatPlugin extends KeepTrackPlugin {
    id = 'FindSatPlugin';
    lastResults_ = [];
    dragOptions = {
        isDraggable: true,
        minWidth: 500,
        maxWidth: 700,
    };
    menuMode = [MenuMode.ADVANCED, MenuMode.ALL];
    sideMenuElementName = 'findByLooks-menu';
    sideMenuElementHtml = html `
  <div id="findByLooks-menu" class="side-menu-parent start-hidden text-select">
    <div id="findByLooks-content" class="side-menu">
      <div class="row">
        <h5 class="center-align">Find Satellite</h5>
        <form id="findByLooks-form">
          <div class="row">
            <div class="input-field col s12">
              <select value=0 id="fbl-type" type="text">
                <option value=0>All</option>
                <option value=1>Payload</option>
                <option value=2>Rocket Body</option>
                <option value=3>Debris</option>
              </select>
              <label for="disabled">Object Type</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12">
              <select value=0 id="fbl-country" type="text">
                <option value='All'>All</option>
              </select>
              <label for="disabled">Country</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12">
              <select value=0 id="fbl-bus" type="text">
                <option value='All'>All</option>
              </select>
              <label for="disabled">Satellite Bus</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12">
              <select value=0 id="fbl-payload" type="text">
                <option value='All'>All</option>
              </select>
              <label for="disabled">Payload</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12">
              <select value=0 id="fbl-shape" type="text">
                <option value='All'>All</option>
              </select>
              <label for="disabled">Shape</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12">
              <select value=0 id="fbl-source" type="text">
                <option value='All'>All</option>
              </select>
              <label for="disabled">Source</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m6 l6">
              <input placeholder="xxx.x" id="fbl-azimuth" type="text">
              <label for="fbl-azimuth" class="active">Azimuth (deg)</label>
            </div>
            <div class="input-field col s12 m6 l6">
              <input placeholder="5" id="fbl-azimuth-margin" type="text">
              <label for="fbl-azimuth-margin "class="active">Margin (deg)</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m6 l6">
              <input placeholder="XX.X" id="fbl-elevation" type="text">
              <label for="fbl-elevation "class="active">Elevation (deg)</label>
            </div>
            <div class="input-field col s12 m6 l6">
              <input placeholder="5" id="fbl-elevation-margin" type="text">
              <label for="fbl-elevation-margin "class="active">Margin (deg)</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m6 l6">
              <input placeholder="xxxx.x" id="fbl-range" type="text">
              <label for="fbl-range "class="active">Range (km)</label>
            </div>
            <div class="input-field col s12 m6 l6">
              <input placeholder="500" id="fbl-range-margin" type="text">
              <label for="fbl-range-margin "class="active">Margin (km)</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m6 l6">
              <input placeholder="XX.X" id="fbl-inc" type="text">
              <label for="fbl-inc "class="active">Inclination (deg)</label>
            </div>
            <div class="input-field col s12 m6 l6">
              <input value="0.5" placeholder="0.5" id="fbl-inc-margin" type="text">
              <label for="fbl-inc-margin "class="active">Margin (deg)</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m6 l6">
              <input placeholder="XX.X" id="fbl-period" type="text">
              <label for="fbl-period "class="active">Period (min)</label>
            </div>
            <div class="input-field col s12 m6 l6">
              <input value="10" placeholder="10" id="fbl-period-margin" type="text">
              <label for="fbl-period-margin "class="active">Margin (min)</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m6 l6">
              <input placeholder="XX.X" id="fbl-tleAge" type="text">
              <label for="fbl-tleAge "class="active">TLE Age (hours)</label>
            </div>
            <div class="input-field col s12 m6 l6">
              <input value="1" placeholder="1" id="fbl-tleAge-margin" type="text">
              <label for="fbl-tleAge-margin "class="active">Margin (hours)</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m6 l6">
              <input placeholder="XX.X" id="fbl-rcs" type="text">
              <!-- RCS in meters squared -->
              <label for="fbl-rcs "class="active">RCS (m<sup>2</sup>)</label>
            </div>
            <div class="input-field col s12 m6 l6">
              <input value="10" placeholder="10" id="fbl-rcs-margin" type="text">
              <label for="fbl-rcs-margin "class="active">Margin (m<sup>2</sup>)</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m6 l6">
              <input placeholder="XX.X" id="fbl-raan" type="text">
              <label for="fbl-raan "class="active">Right Ascension (deg)</label>
            </div>
            <div class="input-field col s12 m6 l6">
              <input value="0.5" placeholder="0.5" id="fbl-raan-margin" type="text">
              <label for="fbl-raan-margin "class="active">Margin (deg)</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m6 l6">
              <input placeholder="XX.X" id="fbl-argPe" type="text">
              <label for="fbl-argPe "class="active">Arg of Perigee (deg)</label>
            </div>
            <div class="input-field col s12 m6 l6">
              <input value="0.5" placeholder="0.5" id="fbl-argPe-margin" type="text">
              <label for="fbl-argPe-margin "class="active">Margin (deg)</label>
            </div>
          </div>
          <div class="row">
          <center>
            <button id="findByLooks-submit" class="btn btn-ui waves-effect waves-light" type="submit"
              name="action">Find Satellite(s) &#9658;
              </button>
            </center>
          </div>
          <div class="row">
          <center>
          <button id="findByLooks-export" class="btn btn-ui waves-effect waves-light" type="button"
            name="action">Export data &#9658;
            </button>
          </center>
          </div>
        </form>
        <div class="row center-align" style="margin-top:20px;">
          <span id="fbl-error" class="menu-selectable"></span>
        </div>
      </div>
    </div>
  </div>`;
    bottomIconImg = findSatPng;
    hasSearchBeenRun_ = false;
    addJs() {
        super.addJs();
        EventBus.getInstance().on(EventBusEvent.uiManagerFinal, this.uiManagerFinal_.bind(this));
    }
    printLastResults() {
        errorManagerInstance.info(this.lastResults_.map((sat) => sat.name).join('\n'));
    }
    uiManagerFinal_() {
        const satData = ServiceLocator.getCatalogManager().objectCache;
        getEl('fbl-error').addEventListener('click', () => {
            getEl('fbl-error').style.display = 'none';
        });
        getEl('findByLooks-form').addEventListener('submit', (e) => {
            e.preventDefault();
            showLoading(() => {
                this.findByLooksSubmit_().then(() => {
                    hideLoading();
                });
            });
        });
        getUnique(satData.filter((obj) => obj?.bus).map((obj) => obj.bus))
            // Sort using lower case
            .sort((a, b) => (a).toLowerCase().localeCompare((b).toLowerCase()))
            .forEach((bus) => {
            getEl('fbl-bus').insertAdjacentHTML('beforeend', `<option value="${bus}">${bus}</option>`);
        });
        countryNameList.forEach((countryName) => {
            getEl('fbl-country').insertAdjacentHTML('beforeend', `<option value="${countryCodeList[countryName]}">${countryName}</option>`);
        });
        getUnique(satData.filter((obj) => obj?.shape).map((obj) => obj.shape))
            // Sort using lower case
            .sort((a, b) => (a).toLowerCase().localeCompare((b).toLowerCase()))
            .forEach((shape) => {
            getEl('fbl-shape').insertAdjacentHTML('beforeend', `<option value="${shape}">${shape}</option>`);
        });
        getUnique(satData.filter((obj) => obj?.source).map((obj) => obj.source))
            // Sort using lower case
            .sort((a, b) => (a).toLowerCase().localeCompare((b).toLowerCase()))
            .forEach((source) => {
            getEl('fbl-source').insertAdjacentHTML('beforeend', `<option value="${source}">${source}</option>`);
        });
        const payloadPartials = satData
            .filter((obj) => obj?.payload)
            .map((obj) => obj.payload
            .split(' ')[0]
            .split('-')[0]
            .replace(/[^a-zA-Z]/gu, ''))
            .filter((obj) => obj.length >= 3);
        getUnique(payloadPartials)
            .sort((a, b) => (a).toLowerCase().localeCompare((b).toLowerCase()))
            .forEach((payload) => {
            if (payload === '') {
                return;
            }
            if (payload.length > 3) {
                getEl('fbl-payload').insertAdjacentHTML('beforeend', `<option value="${payload}">${payload}</option>`);
            }
        });
        // Export data
        getEl('findByLooks-export')?.addEventListener('click', () => {
            if (!this.hasSearchBeenRun_) {
                errorManagerInstance.warn('Try finding satellites first!');
                return;
            }
            CatalogExporter.exportTle2Csv(this.lastResults_);
        });
    }
    findByLooksSubmit_() {
        this.hasSearchBeenRun_ = true;
        return new Promise(() => {
            const uiManagerInstance = ServiceLocator.getUiManager();
            const az = parseFloat(getEl('fbl-azimuth').value);
            const el = parseFloat(getEl('fbl-elevation').value);
            const rng = parseFloat(getEl('fbl-range').value);
            const inc = parseFloat(getEl('fbl-inc').value);
            const period = parseFloat(getEl('fbl-period').value);
            const tleAge = parseFloat(getEl('fbl-tleAge').value);
            const rcs = parseFloat(getEl('fbl-rcs').value);
            const azMarg = parseFloat(getEl('fbl-azimuth-margin').value);
            const elMarg = parseFloat(getEl('fbl-elevation-margin').value);
            const rngMarg = parseFloat(getEl('fbl-range-margin').value);
            const incMarg = parseFloat(getEl('fbl-inc-margin').value);
            const periodMarg = parseFloat(getEl('fbl-period-margin').value);
            const tleAgeMarg = parseFloat(getEl('fbl-tleAge-margin').value);
            const rcsMarg = parseFloat(getEl('fbl-rcs-margin').value);
            const objType = parseInt(getEl('fbl-type').value);
            const raan = parseFloat(getEl('fbl-raan').value);
            const raanMarg = parseFloat(getEl('fbl-raan-margin').value);
            const argPe = parseFloat(getEl('fbl-argPe').value);
            const argPeMarg = parseFloat(getEl('fbl-argPe-margin').value);
            const countryCode = getEl('fbl-country').value;
            const bus = getEl('fbl-bus').value;
            const payload = getEl('fbl-payload').value;
            const shape = getEl('fbl-shape').value;
            const source = getEl('fbl-source').value;
            getEl('search').value = ''; // Reset the search first
            try {
                const searchParams = {
                    az,
                    el,
                    rng,
                    inc,
                    azMarg,
                    elMarg,
                    rngMarg,
                    incMarg,
                    period,
                    periodMarg,
                    tleAge,
                    tleAgeMarg,
                    rcs,
                    rcsMarg,
                    objType,
                    raan,
                    raanMarg,
                    argPe,
                    argPeMarg,
                    countryCode,
                    bus,
                    payload,
                    shape,
                    source,
                };
                this.lastResults_ = FindSatPlugin.searchSats_(searchParams);
                if (this.lastResults_.length === 0) {
                    uiManagerInstance.toast('No Satellites Found', ToastMsgType.critical);
                }
            }
            catch (e) {
                if (e.message === 'No Search Criteria Entered') {
                    uiManagerInstance.toast('No Search Criteria Entered', ToastMsgType.critical);
                }
            }
        });
    }
    static checkAz_(posAll, min, max) {
        return posAll.filter((pos) => {
            if (!pos.isSatellite() && !pos.isMissile()) {
                return false;
            }
            const currentSatellite = ServiceLocator.getCatalogManager().getSat(pos.id, GetSatType.POSITION_ONLY);
            if (!currentSatellite) {
                return false;
            }
            const rae = eci2rae(ServiceLocator.getTimeManager().simulationTimeObj, currentSatellite.position, ServiceLocator.getSensorManager().currentSensors[0]);
            return rae.az >= min && rae.az <= max;
        });
    }
    static checkEl_(posAll, min, max) {
        return posAll.filter((pos) => {
            if (!pos.isSatellite() && !pos.isMissile()) {
                return false;
            }
            const currentSatellite = ServiceLocator.getCatalogManager().getSat(pos.id, GetSatType.POSITION_ONLY);
            if (!currentSatellite) {
                return false;
            }
            const rae = eci2rae(ServiceLocator.getTimeManager().simulationTimeObj, currentSatellite.position, ServiceLocator.getSensorManager().currentSensors[0]);
            return rae.el >= min && rae.el <= max;
        });
    }
    static checkInview_(posAll) {
        const dotsManagerInstance = ServiceLocator.getDotsManager();
        return posAll.filter((pos) => dotsManagerInstance.inViewData[pos.id] === 1);
    }
    static checkObjtype_(posAll, objtype) {
        return posAll.filter((pos) => pos.type === objtype);
    }
    static checkRange_(posAll, min, max) {
        return posAll.filter((pos) => {
            if (!pos.isSatellite() && !pos.isMissile()) {
                return false;
            }
            const currentSatellite = ServiceLocator.getCatalogManager().getSat(pos.id, GetSatType.POSITION_ONLY);
            if (!currentSatellite) {
                return false;
            }
            const rae = eci2rae(ServiceLocator.getTimeManager().simulationTimeObj, currentSatellite.position, ServiceLocator.getSensorManager().currentSensors[0]);
            return rae.rng >= min && rae.rng <= max;
        });
    }
    static limitPossibles_(possibles, limit) {
        const uiManagerInstance = ServiceLocator.getUiManager();
        if (possibles.length >= limit) {
            uiManagerInstance.toast(`Too many results, limited to ${limit}`, ToastMsgType.serious);
        }
        possibles = possibles.slice(0, limit);
        return possibles;
    }
    static searchSats_(searchParams) {
        let { az, el, rng, countryCode, inc, azMarg, elMarg, rngMarg, incMarg, period, periodMarg, tleAge, tleAgeMarg, rcs, rcsMarg, objType, raan: rightAscension, raanMarg: rightAscensionMarg, argPe, argPeMarg, bus, shape, payload, source, } = searchParams;
        const isValidAz = !isNaN(az) && isFinite(az);
        const isValidEl = !isNaN(el) && isFinite(el);
        const isValidRange = !isNaN(rng) && isFinite(rng);
        const isValidInc = !isNaN(inc) && isFinite(inc);
        const isValidRaan = !isNaN(rightAscension) && isFinite(rightAscension);
        const isValidArgPe = !isNaN(argPe) && isFinite(argPe);
        const isValidPeriod = !isNaN(period) && isFinite(period);
        const isValidTleAge = !isNaN(tleAge) && isFinite(tleAge);
        const isValidRcs = !isNaN(rcs) && isFinite(rcs);
        const isSpecificCountry = countryCode !== 'All';
        const isSpecificBus = bus !== 'All';
        const isSpecificShape = shape !== 'All';
        const isSpecificSource = source !== 'All';
        const isSpecificPayload = payload !== 'All';
        azMarg = !isNaN(azMarg) && isFinite(azMarg) ? azMarg : 5;
        elMarg = !isNaN(elMarg) && isFinite(elMarg) ? elMarg : 5;
        rngMarg = !isNaN(rngMarg) && isFinite(rngMarg) ? rngMarg : 200;
        incMarg = !isNaN(incMarg) && isFinite(incMarg) ? incMarg : 1;
        periodMarg = !isNaN(periodMarg) && isFinite(periodMarg) ? periodMarg : 0.5;
        tleAgeMarg = !isNaN(tleAgeMarg) && isFinite(tleAgeMarg) ? tleAgeMarg : 1;
        rcsMarg = !isNaN(rcsMarg) && isFinite(rcsMarg) ? rcsMarg : rcs / 10;
        rightAscensionMarg = !isNaN(rightAscensionMarg) && isFinite(rightAscensionMarg) ? rightAscensionMarg : 1;
        argPeMarg = !isNaN(argPeMarg) && isFinite(argPeMarg) ? argPeMarg : 1;
        if (!isValidEl &&
            !isValidRange &&
            !isValidAz &&
            !isValidInc &&
            !isValidPeriod &&
            !isValidTleAge &&
            !isValidRcs &&
            !isValidArgPe &&
            !isValidRaan &&
            !isSpecificCountry &&
            !isSpecificBus &&
            !isSpecificShape &&
            !isSpecificSource &&
            !isSpecificPayload) {
            throw new Error('No Search Criteria Entered');
        }
        let res = ServiceLocator.getCatalogManager().getSats();
        res = !isValidInc && !isValidPeriod && !isValidTleAge && (isValidAz || isValidEl || isValidRange) ? FindSatPlugin.checkInview_(res) : res;
        res = objType !== 0 ? FindSatPlugin.checkObjtype_(res, objType) : res;
        if (isValidAz) {
            res = FindSatPlugin.checkAz_(res, az - azMarg, az + azMarg);
        }
        if (isValidEl) {
            res = FindSatPlugin.checkEl_(res, el - elMarg, el + elMarg);
        }
        if (isValidRange) {
            res = FindSatPlugin.checkRange_(res, rng - rngMarg, rng + rngMarg);
        }
        if (isValidInc) {
            res = FindSatPlugin.checkInc_(res, (inc - incMarg), (inc + incMarg));
        }
        if (isValidRaan) {
            res = FindSatPlugin.checkRightAscension_(res, (rightAscension - rightAscensionMarg), (rightAscension + rightAscensionMarg));
        }
        if (isValidArgPe) {
            res = FindSatPlugin.checkArgPe_(res, (argPe - argPeMarg), (argPe + argPeMarg));
        }
        if (isValidPeriod) {
            res = FindSatPlugin.checkPeriod_(res, (period - periodMarg), (period + periodMarg));
        }
        if (isValidTleAge) {
            res = FindSatPlugin.checkTleAge_(res, (tleAge - tleAgeMarg), (tleAge + tleAgeMarg));
        }
        if (isValidRcs) {
            res = FindSatPlugin.checkRcs_(res, rcs - rcsMarg, rcs + rcsMarg);
        }
        if (countryCode !== 'All') {
            let country = countryCode.split('|');
            // Remove duplicates and undefined
            country = country.filter((item, index) => item && country.indexOf(item) === index);
            res = res.filter((obj) => country.includes(obj.country));
        }
        if (bus !== 'All') {
            res = res.filter((obj) => obj.bus === bus);
        }
        if (shape !== 'All') {
            res = res.filter((obj) => obj.shape === shape);
        }
        if (source !== 'All') {
            res = res.filter((obj) => obj.source === source);
        }
        if (payload !== 'All') {
            res = res.filter((obj) => obj.payload
                ?.split(' ')[0]
                ?.split('-')[0]
                ?.replace(/[^a-zA-Z]/gu, '') === payload);
        }
        res = FindSatPlugin.limitPossibles_(res, settingsManager.searchLimit);
        let result = '';
        res.forEach((obj, i) => {
            result += i < res.length - 1 ? `${obj.sccNum},` : `${obj.sccNum}`;
        });
        getEl('search').value = result;
        const uiManagerInstance = ServiceLocator.getUiManager();
        uiManagerInstance.doSearch(getEl('search').value);
        return res;
    }
    static checkArgPe_(possibles, min, max) {
        return possibles.filter((possible) => possible.argOfPerigee < max && possible.argOfPerigee > min);
    }
    static checkInc_(possibles, min, max) {
        return possibles.filter((possible) => possible.inclination < max && possible.inclination > min);
    }
    static checkPeriod_(possibles, minPeriod, maxPeriod) {
        return possibles.filter((possible) => possible.period > minPeriod && possible.period < maxPeriod);
    }
    static checkTleAge_(possibles, minTleAge_, maxTleAge) {
        const minTleAge = minTleAge_ < 0 ? 0 : minTleAge_;
        const now = new Date();
        return possibles.filter((possible) => {
            const ageHours = possible.ageOfElset(now);
            return ageHours >= minTleAge && ageHours <= maxTleAge;
        });
    }
    static checkRightAscension_(possibles, min, max) {
        return possibles.filter((possible) => possible.rightAscension < max && possible.rightAscension > min);
    }
    static checkRcs_(possibles, minRcs, maxRcs) {
        return possibles.filter((possible) => (possible?.rcs ?? -Infinity) > minRcs && (possible?.rcs ?? Infinity) < maxRcs);
    }
}
